import { RecordEscrowDisbursementApiRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateDisbursement = makeValidator({
  FieldParser: RecordEscrowDisbursementApiRow,
});
